import { Component, OnInit, Input,LOCALE_ID, Inject } from '@angular/core';
import { PageItem } from '../page';
import { PageService } from '../page.service';


@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  @Input() pages : PageItem[];
  homeImage = "industria-paisaia.es.svg";
  logoIndustriaPaisaia:string;

  constructor(
    @Inject(LOCALE_ID) protected localeId: string,
    private pageService: PageService,
  ) { }

  ngOnInit() {
    if (this.localeId==='es') this.homeImage = "industria-paisaia.es.svg";
    else if (this.localeId==='eu') this.homeImage = "industria-paisaia.svg";

     this.logoIndustriaPaisaia = "/"+this.localeId+"/assets/"+this.homeImage;

    //console.log(this.pages);
    // this.pages = this.pages.filter(page => page.slug != 'texto-legal');
  }

  getLink(locale) {
    return "/"+locale+"/"+this.pageService.getLink(locale);
  }

}
